const statisticsRo = {
    "user_statistics": "Statistici utilizatori",
    "menu_item_clicks": "Clicuri pe elementele de meniu",
    "statistics": "Statistici",
    "user_traffic": "Trafic de utilizatori",
    "last_7_days": "Ultimele 7 zile",
    "last_30_days": "Ultimele 30 de zile",
    "menu_item": "Element de meniu",
    "click_count": "Număr de clicuri",
    "error_fetching_user_statistics": "Eroare la preluarea statisticilor utilizatorului.",
    "error_fetching_menu_item_statistics": "Eroare la preluarea statisticilor elementului de meniu.",
    "statistics_feature_not_available": "Funcția de statistici este disponibilă doar în abonamentul PRO. Vă rugăm să faceți upgrade la abonament pentru a accesa această funcție.",
    "change_subscription_plan": "Schimbați planul de abonament",
    "permission_denied": "Acces refuzat",
    "error_fetching_rating_statistics": "Eroare la preluarea statisticilor de evaluare.",
    "menu_item_ratings": "Evaluări ale elementelor din meniu",
    "likes": "aprecieri",
    "dislikes": "nu-mi place",
    "rating_trends_last_7_days": "Tendințe de rating (ultimele 7 zile)",
    "rating_trends_last_30_days": "Tendințe de rating (ultimele 30 de zile)"
};

export default statisticsRo;
